import { Separator } from '@ais-ui/ui-core';

import { useLocalization } from '@ais-ui/locale-management';
import { ReportForm } from './ReportForm';

export function SettingsReportsPage() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">
          {messages.settingsReportsTitle}
        </h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsReportsSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsReportsListTitle}
        </h3>
      </div>
      <ReportForm />
    </div>
  );
}
